import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfDeletedMissionAction = createAsyncThunk(
    'menu-delete-mission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/delete-mission?s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfDeletedMissionSlice = createSlice({
    name: 'menu-delete-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfDeletedMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfDeletedMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfDeletedMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfDeletedMissionReducer = noOfDeletedMissionSlice.reducer